import { render, staticRenderFns } from "./GetAll.vue?vue&type=template&id=18d8f801&scoped=true&"
import script from "./GetAll.vue?vue&type=script&lang=js&"
export * from "./GetAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d8f801",
  null
  
)

export default component.exports